import axios from "axios";

let requestInterceptorId = null;

const AUTH_FAILURE_CODES = new Set([
  "invalid_grant",
  "login_required",
  "missing_refresh_token",
  "consent_required",
]);

const isAuthFailure = (err) => {
  if (!err) return false;
  if (AUTH_FAILURE_CODES.has(err.error)) return true;
  const msg = err.message || "";
  return (
    msg.includes("invalid_grant") ||
    msg.includes("Missing Refresh Token") ||
    msg.includes("Unknown or invalid refresh token") ||
    msg.includes("Login required")
  );
};

export const setupAxiosInterceptors = (
  getAccessTokenSilently,
  setAccessToken,
  logout,
) => {
  if (requestInterceptorId !== null) {
    axios.interceptors.request.eject(requestInterceptorId);
    requestInterceptorId = null;
  }

  requestInterceptorId = axios.interceptors.request.use(
    async (config) => {
      const shouldSkipAuth = config.url?.includes("reports.4sightlabs.com");

      if (!shouldSkipAuth) {
        try {
          const token = await getAccessTokenSilently();
          if (token) {
            setAccessToken(token);
            config.headers = config.headers || {};
            config.headers.Authorization = `Bearer ${token}`;
          }
        } catch (err) {
          console.error("[apiClient] Token acquisition failed:", err);
          if (isAuthFailure(err) && typeof logout === "function") {
            logout({
              logoutParams: { returnTo: window.location.origin },
            });
          }
          return Promise.reject(err);
        }
      }

      return config;
    },
    (error) => Promise.reject(error),
  );

  return () => {
    if (requestInterceptorId !== null) {
      axios.interceptors.request.eject(requestInterceptorId);
      requestInterceptorId = null;
    }
  };
};
